import React from 'react'
import AdminBillingAccountDetailContext from './context'
import InvoicesTable from 'components/InvoicesTable'

const AdminBillingAccountDetailInvoices: React.FC = () => {
    const {
        invoiceSearchForm,
        updateInvoiceSearchForm,
        setInvoiceSearchForm,
    } = React.useContext(AdminBillingAccountDetailContext)
    
    return (
        <InvoicesTable 
            form={invoiceSearchForm}
            updateForm={updateInvoiceSearchForm}
            setForm={setInvoiceSearchForm}
            isAdmin={true}
        />
    )
}

export default AdminBillingAccountDetailInvoices